module.exports = __webpack_public_path__ + "static/media/nodeFirstPost.4cede17d.png";